import { render, staticRenderFns } from "./ModalErrorSender.vue?vue&type=template&id=2fb6e79a&"
import script from "./ModalErrorSender.vue?vue&type=script&lang=js&"
export * from "./ModalErrorSender.vue?vue&type=script&lang=js&"
import style0 from "./ModalErrorSender.vue?vue&type=style&index=0&id=2fb6e79a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports